import axios from "axios";

import { Cookies } from "../utils/functions";
import { APIS } from "../configs";
import { COOKIES } from "../utils/constants";

/**
 * axioAuth
 */
export const axiosAuth = (() => {
  const instance = axios.create({
    baseURL: APIS.AUTH_BASE_URL,
  });

  instance.interceptors.response.use(
    (response) => response,
    (err) => {
      const apiErr = new Error(
        err.response?.data?.error || "Ha ocurrido un error, intente más tarde.",
      );

      if (err.response?.status === 401) {
        Cookies.remove(COOKIES.SESSION.NAME);
        window.location.replace(window.location.origin);

        return Promise.reject(apiErr);
      }

      return Promise.reject(apiErr);
    },
  );

  return instance;
})();

/**
 * axiosDash
 */
export const axiosDash = (() => {
  const instance = axios.create({
    baseURL: APIS.DASH_BASE_URL,
  });

  instance.interceptors.response.use(
    (response) => response,
    (err) => {
      const apiErr = new Error(
        err.response?.data?.error || "Ha ocurrido un error, intente más tarde.",
      );

      if (err.response?.status === 401) {
        Cookies.remove(COOKIES.SESSION.NAME);
        window.location.replace(window.location.origin);

        return Promise.reject(apiErr);
      }

      return Promise.reject(apiErr);
    },
  );

  return instance;
})();

/**
 * Set the user token on default header
 */
export const setAuthToken = (token: string | null): void => {
  if (token) {
    axiosAuth.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    axiosDash.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosAuth.defaults.headers.common["Authorization"];
    delete axiosDash.defaults.headers.common["Authorization"];
  }
};
